import { CATEGORIES, type CategoryId } from '@/data/categories';
import { CURRENCIES, type CurrencyCode } from '@/lib/currency';

interface FilterBarProps {
  search: string;
  onSearch: (s: string) => void;
  category: CategoryId | 'all';
  onCategory: (c: CategoryId | 'all') => void;
  currency: CurrencyCode;
  onCurrency: (c: CurrencyCode) => void;
  partCount: number;
}

export default function FilterBar({
  search,
  onSearch,
  category,
  onCategory,
  currency,
  onCurrency,
  partCount,
}: FilterBarProps) {
  return (
    <>
      <div className="filter-bar">
        <div className="filter-search">
          <input
            type="text"
            placeholder="Search by part name, casting #, year, or vehicle…"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        <select
          value={currency}
          onChange={(e) => onCurrency(e.target.value as CurrencyCode)}
          style={{ fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.1em', padding: '10px 14px' }}
          aria-label="Currency"
        >
          {CURRENCIES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <div style={{ color: 'var(--text-muted)', fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.15em' }}>
          {partCount} SHOWN
        </div>
      </div>
      <div className="filter-bar">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            type="button"
            className={`chip${c.id === category ? ' active' : ''}`}
            onClick={() => onCategory(c.id)}
          >
            {c.label}
          </button>
        ))}
      </div>
    </>
  );
}
